import { render, staticRenderFns } from "./selectSchoolPanel.vue?vue&type=template&id=7f4cf8b0&scoped=true&"
import script from "./selectSchoolPanel.vue?vue&type=script&lang=js&"
export * from "./selectSchoolPanel.vue?vue&type=script&lang=js&"
import style0 from "./selectSchoolPanel.vue?vue&type=style&index=0&id=7f4cf8b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4cf8b0",
  null
  
)

export default component.exports